import posed from 'react-pose'

export const Screen = posed.div({
  enter: {
    x: 0,
    opacity: 1,
    transition: {
      delay: 200,
      duration: 200,
    },
  },
  exit: {
    x: 20,
    opacity: 0,
    transition: {
      duration: 200,
    },
  },
}) as any
